import React from 'react'

import { UpArrow, DownArrow } from '../Arrows'

export default ({
    label,
    toggleWindowDropdown,
    displayWindowDropdown,
    inHeader=true
}) => {
    return (
        <div
            className="panelButton"
            onClick={() =>
                toggleWindowDropdown(!displayWindowDropdown)
            }
        >
            <span className="panelTimeOptionText">{label}</span>
            <span className="panelTimeOptionDropdown">
                {displayWindowDropdown ? <UpArrow className={`${inHeader ? 'is-white' : ''}`}/> : <DownArrow className={`${inHeader ? 'is-white' : ''}`}/>}
            </span>
        </div>
    )
}
